export enum SINGLE_SELECT_TYPE {
  RADIO = 1,
  BUTTONS = 2,
  RADIO_VERTICAL = 3,
}
